import { Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ButtonInduxtry, SelectInput, Warning } from '../../../../../utils/models/input.interface';
import { returnColorWarning, returnTextWarning, returnWarningIcon } from '../../../functions/utilities.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SelectInputComponent,
    },
  ],
})
export class SelectInputComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
  warningIconSelectInput = returnWarningIcon;
  colorWarningSelectInput = returnColorWarning;
  textWarningSelectInput = returnTextWarning;

  searchFormControl = new FormControl()

  @Input() selectInput: SelectInput;
  @Input() loading = false;
  @Input() warning: Warning = {
    sucess: null,
    error: null,
    info: null,
    alert: null,
    load: null
  };

  buttonInterfaceElongated: ButtonInduxtry;
  valuePage = 1

  filteredOptions: any[] = [];

  private _onDestroy = new Subject<void>();

  get optionsToDisplay(): any[] {
    // Se filteredOptions tem itens ou se selectInput.options não está disponível, usa filteredOptions
    // Caso contrário, se filteredOptions está vazio mas selectInput.options tem itens, usa selectInput.options
    if (this.filteredOptions.length > 0 || !this.selectInput?.options) {
      return this.filteredOptions;
    }
    // Se filteredOptions está vazio mas as opções originais existem, inicializa
    if (this.selectInput?.options && this.selectInput.options.length > 0) {
      this.initializeOptions();
      return this.filteredOptions;
    }
    return this.filteredOptions;
  }


  @Output() valueEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Output() endScroll: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() page: EventEmitter<number> = new EventEmitter<number>();


  writeValue(value: any): void {
    this.selectInput.value = value;
  }

  onChange = (value: any) => {
    return value;
  };

  onTouched = (value: unknown) => {
    return value;
  };

  registerOnChange(onChange: (value: any) => any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  ngOnInit(): void {
    // Inicializa as opções se já estiverem disponíveis
    this.initializeOptions();
    
    // Configura o filtro de busca
    this.searchFormControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(value => {
        if (value && value.trim() !== '') {
          this.filterOptions(value);
        } else {
          // Se o campo estiver vazio, mostra todas as opções
          this.initializeOptions();
        }
      });
    
    this.buttonInterfaceElongated = { label: 'LIMPAR', elongated: true, customStyle: 'secondary', showLabel: true }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Atualiza as opções quando selectInput.options mudar
    if (changes.selectInput && changes.selectInput.currentValue?.options) {
      this.initializeOptions();
      // Se houver um valor de busca, reaplica o filtro
      if (this.searchFormControl.value && this.searchFormControl.value.trim() !== '') {
        this.filterOptions(this.searchFormControl.value);
      }
    }
  }

  initializeOptions(): void {
    if (this.selectInput?.options) {
      this.filteredOptions = [...this.selectInput.options];
    } else {
      this.filteredOptions = [];
    }
  }

  filterOptions(search: string) {
    if (!this.selectInput?.options) {
      return;
    }
    
    const searchValue = (search || '').toLowerCase().trim();
    if (!searchValue) {
      this.initializeOptions();
      return;
    }
    
    this.filteredOptions = this.selectInput.options.filter(
      (opt: any) => opt?.viewValue?.toLowerCase().includes(searchValue)
    );
  }

  setNewValue() {
    this.onChange(this.selectInput.value);
    this.valueEmitter.emit({option: this.selectInput.value});
  }

  genericButton(value) {
    this.selectInput.value = undefined;
    this.valueEmitter.emit({option: this.selectInput.value});
    this.searchFormControl.setValue('', { emitEvent: false });
    this.initializeOptions();
  }

  onSelectScroll(value) {}

  infiniteScroll() {
    if(!this.loading){
      this.valuePage ++
      this.endScroll.emit(true)
      this.page.emit(this.valuePage)
    }
  }

   ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
